import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { DataTable } from '@pascalhonegger/ng-datatable';
import { DatePipe } from '@angular/common';
import { OffersService } from '../../../../services/offers/offers.service';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'app-my-services',
  templateUrl: './my-services.component.html',
  styleUrls: ['./my-services.component.scss'],
})
export class MyServicesComponent implements OnInit {
  @ViewChild('DataTableBadge') DataTableBadge: DataTable;
  @ViewChild('DataTableApk') DataTableApk: DataTable;
  @ViewChild('DataTableXchange') DataTableXchange: DataTable;
  @ViewChild('DataTableSupp') DataTableSupp: DataTable;

  loadingSpinner = false;
  offers: any;
  dataBadge = [];
  AllBadge: any;
  dataApk = [];
  AllApk: any;
  dataXchange = [];
  allXchange: any;
  dataSupport = [];
  AllSupport: any;
  isContractActive: boolean;
  activationHistory;
  displayDetailsModal = false;

  constructor(
    private readonly constantService: ConstantService,
    private readonly offerService: OffersService,
    private readonly datePipe: DatePipe,
    private readonly ref: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.getOffersHistory();
    this.isContractActive = JSON.parse(
      localStorage.getItem('enterprise')
    ).hasActiveContract;
  }

  /**
   * function called to initialize offers data
   */
  getOffersHistory() {
    this.loadingSpinner = true;
    this.offerService.getOfferHistory().subscribe((data: any) => {
      this.offers = data.data;
      this.showDataTable(this.offers);
    });
  }

  /**
   * function called to filter data table based on object data passed
   */
  async showDataTable(data) {
    // badges Data table
    data.badges.forEach((row) => {
      this.dataBadge.push({
        createdAt: row ? this.datePipe.transform(row.createdAt, 'yyyy-MM-dd hh:mm') : '--',
        Price: row.offer.price ? row.offer.price.toFixed(2) : 0,
        activationHistory: row.activationHistory ? row.activationHistory : []
      });
    });
    this.AllBadge = this.dataBadge;
    // apk Data table
    await data.custom_mobile_app.forEach((row) => {
      this.dataApk.push({
        createdAt: row ? this.datePipe.transform(row.createdAt, 'yyyy-MM-dd hh:mm') : '--',
        Price: row.offer.price ? row.offer.price.toFixed(2) : 0,
        activationHistory: row.activationHistory ? row.activationHistory : []
      });
    });
    this.AllApk = this.dataApk;

    // exchange Data table
    await data.xchange.forEach((row) => {
      this.dataXchange.push({
        createdAt: row ? this.datePipe.transform(row.createdAt, 'yyyy-MM-dd hh:mm') : '--',
        Price: row.offer.price ? row.offer.price.toFixed(2) : 0,
        activationHistory: row.activationHistory ? row.activationHistory : []
      });
    });
    this.allXchange = this.dataXchange;

    // support Data table
    await data.support.forEach((row) => {
      this.dataSupport.push({
        createdAt: row ? this.datePipe.transform(row.createdAt, 'yyyy-MM-dd hh:mm') : '--',
        Price: row.offer.price ? row.offer.price.toFixed(2) : 0,
        activationHistory: row.activationHistory ? row.activationHistory : []
      });
    });
    this.AllSupport = this.dataSupport;

    this.loadingSpinner = false;
    this.ref.detectChanges();
  }

  paginateChangeBadge(event) {
    this.DataTableBadge.setPage(1, this.DataTableBadge.rowsOnPage);
  }

  openDialog(action, data?){
    switch (action) {
      case 'details':
        this.activationHistory = data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        this.displayDetailsModal = true;
        break;
      default:
        this.constantService.showErrorToast('toast.error_server');
        break;
    }
  }

  redirectAvailableServices(service) {
    this.constantService.navigateToService('/available' , service);
  }
  /**
   * function is called to redirect to add-contract.
   */
  goContract() {
    this.constantService.navigateToAddContract();
  }
}
